import {
  SUPERSET_CSAT_SATISFIED_DATA,
  SUPERSET_CSAT_SATISFIED_DATA_SUCCESS,
  SUPERSET_CSAT_SATISFIED_DATA_ERROR,
  SUPERSET_CSAT_SATISFIED_DATA_EMPTY,
} from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetCSATSatisfiedData = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_CSAT_SATISFIED_DATA:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_CSAT_SATISFIED_DATA_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_CSAT_SATISFIED_DATA_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPERSET_CSAT_SATISFIED_DATA_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetCSATSatisfiedData;
